// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0245affb","732":"7379264f","977":"de081c1f"}[chunkId] + ".chunk.js";
};